"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var elog = require("@reverbdotcom/commons/dist/elog");
var identify_shopper_1 = require("./identify_shopper");
var challenge_shopper_modal_1 = require("./challenge_shopper_modal");
var rql_1 = require("../../schemas/rql");
var TAG = 'adyen.threeds2_interaction';
function ThreeDS2Interaction(props) {
    /**
     * onError will be called concurrently with the complete function, so the most
     * action we can take is to also log the error, since complete should continue
     * to submit the call to pay
     */
    function onError(e) {
        elog.info(TAG + ".error", { error_message: e.message, paymentStatus: props.paymentStatus });
    }
    if (props.paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.IDENTIFY_SHOPPER_REQUIRED) {
        return (React.createElement(identify_shopper_1.default, { key: props.fingerprintToken, fingerprintToken: props.fingerprintToken, onComplete: props.onIdentifyShopperComplete, onError: onError }));
    }
    if (props.paymentStatus === rql_1.core_apimessages_AdyenPaymentResult_PaymentStatus.CHALLENGE_SHOPPER_REQUIRED) {
        return (React.createElement(challenge_shopper_modal_1.default, { key: props.challengeToken, challengeToken: props.challengeToken, onComplete: props.onChallengeShopperComplete, onError: onError }));
    }
    return null;
}
exports.default = ThreeDS2Interaction;
//# sourceMappingURL=threeds2_interaction.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/threeds2/threeds2_interaction.js
// module id = hec3
// module chunks = 20 21 22